var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { useLink } from '../hooks/use-link';
import { Dot } from './dot';
var cls = classNames('entity-dot-link');
export var DotLinkDefaultProps = {
  spaceUnits: 3,
  target: '_blank',
  dotProps: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    a {\n      color: inherit;\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n      text-decoration: none;\n\n      &:hover {\n        ", "\n        .shp--dot {\n          filter: brightness(1.1);\n        }\n      }\n    }\n  "], ["\n    display: flex;\n    a {\n      color: inherit;\n      display: flex;\n      align-items: center;\n      flex-direction: row;\n      text-decoration: none;\n\n      &:hover {\n        ", "\n        .shp--dot {\n          filter: brightness(1.1);\n        }\n      }\n    }\n  "])), function (_a) {
    var _color = _a._color;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n          color: ", ";\n        "], ["\n          color: ", ";\n        "])), theme.COLOR(_color));
  })
});
var DotStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-shrink: 0;\n    ", "\n  "], ["\n    flex-shrink: 0;\n    ", "\n  "])), function (_a) {
    var spaceUnits = _a.spaceUnits;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n      margin-right: ", ";\n    "], ["\n      margin-right: ", ";\n    "])), theme.UNIT(spaceUnits));
  })
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Dot: styled(Dot)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), DotStyles)
};
export var DotLink = function (props) {
  var className = props.className,
    children = props.children,
    href = props.href,
    spaceUnits = props.spaceUnits,
    target = props.target,
    dotProps = props.dotProps;
  var Link = useLink().Link;
  return React.createElement(My.Container, {
    _color: dotProps.color,
    className: cls.name(className)
  }, React.createElement(Link, {
    target: target,
    href: href
  }, React.createElement(My.Dot, __assign({
    color: dotProps.color,
    spaceUnits: spaceUnits
  }, dotProps)), children));
};
DotLink.cls = cls;
DotLink.defaultProps = DotLinkDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;